import { Component, OnInit, Input } from '@angular/core';
import { ConcentreComponent } from './concentre/concentre.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { RelatoComponent } from './relato/relato.component';
import { CrednetComponent } from './crednet/crednet.component';
import { SerasaService } from '../../service/serasa.service';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
  selector: 'app-serasa',
  templateUrl: './serasa.component.html',
  styleUrls: ['./serasa.component.scss'],
  providers: [SerasaService]
})
export class SerasaComponent implements OnInit {
        
  @Input("userID") userID;
  @Input("serasaObj") serasaObj;
  private serasaList; 
  private resultCountSerasa;
  private currentPage = 0;

  constructor(private dialogService: DialogService,
              private serasaService: SerasaService,
              private flashMessagesService: FlashMessagesService) { }
 

  ngOnInit() {
    this.getSerasaHistory();
  }

  getSerasaHistory(){
    this.serasaService.getSerasaHistory(this.userID, this.currentPage).subscribe(result =>{
      if (result.Result){
        this.serasaList = result.Result;
        this.resultCountSerasa = result.Count;
        console.log(this.resultCountSerasa);
        console.log(result);
      }else{
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
        console.log(result);
    }
  }, error => {
      this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
    });
  }


  showModal(type, serasaObj){
    if (type == 1){
    this.dialogService.addDialog(ConcentreComponent, {serasaObj: serasaObj}, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
    }

    if (type == 2){
      this.dialogService.addDialog(CrednetComponent, {serasaObj: serasaObj}, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
    }

    if (type == 3){
      this.dialogService.addDialog(RelatoComponent, {serasaObj: serasaObj}, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
    }
  }

  onSelectSerasa(serasaID, tipoSerasa){

    this.serasaService.requestSerasaByID(serasaID).subscribe(result =>{
      if (result.Result){
        this.showModal(tipoSerasa, result.Result);
      }else{
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
        console.log(result);
    }
  }, error => {
      this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
    });

  }


  paginar($event, type) {
			this.currentPage = $event;
			this.getSerasaHistory();
		}
}



// WEBPACK FOOTER //
// ./src/app/serasa/component/serasa/serasa.component.ts